export const EXPERIENCES = ['wall', 'visual', 'talk', 'circles'];
export function hasMedia(post) {
  return !!post?.image || !!post?.media?.length;
}
/** Bounded horizontal swipe; nested media controls must be excluded by the caller. */
export function swipeMode(current, dx, dy) {
  if (Math.abs(dx) < 80 || Math.abs(dx) < Math.abs(dy) * 1.5) return current;
  const index = EXPERIENCES.indexOf(current);
  return EXPERIENCES[Math.max(0, Math.min(EXPERIENCES.length - 1, index + (dx < 0 ? 1 : -1)))];
}
